import "./price_list.css";
import Image from "../../assets/images/SI-EP-Key-Visual-16x9_original.jpg";
import SnackbarCustom from "../../components/Snackbar/Snackbar";
import { useSelector } from "react-redux";
import { useState } from "react";
import * as FileSaver from 'file-saver';
import { downloadPDF } from "../../redux/API/api_PriceList";
import Loading from "../../components/Loading/Loading.js";

const PriceList = () => {
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const handleSnackOpen = (text, type) => {
      setSnackMessage(text);
      setAlertType(type);
      setOpen(true);
    };
 // snackbar close
 const handleClose = (e) => {
  setOpen(false);
};

  

 const downloadPdf= () => {
  setIsLoader(true);
  downloadPDF(siteToken,
    azureToken.token,
    UID.id,
    userDetails.userEmail,
    userDetails.gid,
    userDetails.roleName,
    userDetails.roleId)
    .then((response) => {
        if (response.status === 200) {
            if (response.data.byteLength <= 200) {
                handleSnackOpen("No Records are Found", "success");
            } else {

                const fileName = "EP PBD1 Internal Pricelist_July26";
                var blob = new Blob([response.data], {
                    type: "application/pdf",
                });
                FileSaver.saveAs(blob, fileName + ".pdf");
                handleSnackOpen("Price List downloaded.", "success");
            }
            setIsLoader(false);
        } else {
            handleSnackOpen("Price List not Available to Download.", "error");
            setIsLoader(false);
        }
    })
    .catch((error) => {
        handleSnackOpen("Error while downloading Price List.", "error");
        setIsLoader(false);
    })
  }

  return (
    <div className="container11">
      <div className="header">SI EP PBD1 Internal Price List</div>
      <div className="content-wrapper">
        <div className="left-content">
          <div className="image">
            <img src={Image} alt="testing" />
          </div>
        </div>

        <div className="right-content">
          <div className="text">
            <p>
              The SI EP PBD1 Internal Pricelist is a confidential document of SI
              EP and the copy you download is for your reference only. It is not
              to be shared with anyone inside or outside the SIEMENS
              organization. Sharing this document in anyway electronic or
              otherwise will be a violation of the SIEMENS compliance
              guidelines.
            </p>
            <button className="download-btn" onClick={downloadPdf}>
              Agree and Download
            </button>
            <p className="disclimer">
              Disclaimer: Product upgradation is a continuous process. Hence,
              data in this pricelist is subject to change without prior notice.
              For the latest information, please get in touch with Product
              Management.
            </p>
          </div>
        </div>
        {isLoader ? <Loading loaderText="Loading...!" /> : <></>}
      </div>

        <SnackbarCustom
                  open={open}
                  message={snackMessage}
                  alertType={alertType}
                  handleClose={handleClose}
                />
              
    </div>
  );
};

export default PriceList;
